import { Component, HostListener, OnInit } from "@angular/core";
import { filter } from "rxjs/operators";
import { NavigationEnd, Router } from "@angular/router";
import { UrlService } from "./Services/url.service";
import { SeoService } from "./Services/seo.service";
import { TranslationService } from "./Services/translation.service";
@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnInit {
  title = "WissalUnivers";

  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(
    private router: Router,
    private urlService: UrlService,
    private seoService: SeoService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    console.log('app compoenent')
    this.translationService.init();
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl!);
        this.seoService.applyRoute(
          this.router.routerState.snapshot.root,
          event.urlAfterRedirects
        );
      });
  }

  /**
   * admin-common renders many internal links as plain hrefs (carousel, footer, store cards...), which reload the
   * whole app. Route every same-site link through the router instead; links already handled (routerLink, a
   * component calling preventDefault), new-tab clicks, downloads and external URLs are left alone.
   */
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }
    const anchor = (event.target as HTMLElement | null)?.closest("a");
    const href = anchor?.getAttribute("href");
    if (
      !anchor ||
      !href ||
      !href.startsWith("/") ||
      href.startsWith("//") ||
      anchor.hasAttribute("download") ||
      (anchor.target && anchor.target !== "_self")
    ) {
      return;
    }
    event.preventDefault();
    // some links still use the old hash format: /#/products/...
    this.router.navigateByUrl(href.replace(/^\/#/, "") || "/").then();
  }
}
